import React from "react";

const AppLoadingGhost = () => {
  return (
    <div className="app-loading-ghost-wrapper">
      {/* We leave this empty for now to maintain a clean solid background */}
    </div>
  );
};

export default AppLoadingGhost;
